import React, { useState } from 'react';
import LoginScreen from './LoginScreen';
import RegisterScreen from './RegisterScreen';
import ForgotPasswordScreen from './ForgotPasswordScreen';

const AuthModal = ({ isOpen, onClose }) => {
  const [mode, setMode] = useState('login'); // 'login', 'register', or 'forgot-password'

  if (!isOpen) return null;

  const handleSwitchToRegister = () => setMode('register');
  const handleSwitchToLogin = () => setMode('login');
  const handleSwitchToForgotPassword = () => setMode('forgot-password');

  return (
    <div className="flex-1 inset-0 z-50">
      {/* Auth Screen Content - each screen provides its own full background */}
      {mode === 'login' ? (
        <LoginScreen
          onSwitchToRegister={handleSwitchToRegister}
          onClose={onClose}
          onForgotPassword={handleSwitchToForgotPassword}
        />
      ) : mode === 'register' ? (
        <RegisterScreen
          onSwitchToLogin={handleSwitchToLogin}
          onClose={onClose}
          onForgotPassword={handleSwitchToForgotPassword}
        />
      ) : (
        <ForgotPasswordScreen
          onBack={handleSwitchToLogin}
        />
      )}
    </div>
  );
};

export default AuthModal;
